export default function StepsSection() {
  const steps = [
    {
      step: '01',
      icon: 'ri-user-add-line',
      title: '注册账号',
      desc: '填写手机号快速注册，30秒完成',
    },
    {
      step: '02',
      icon: 'ri-gift-line',
      title: '选择彩金',
      desc: '浏览各类送彩金活动，选择心仪类型',
    },
    {
      step: '03',
      icon: 'ri-check-double-line',
      title: '领取彩金',
      desc: '按活动规则操作，彩金自动到账',
    },
    {
      step: '04',
      icon: 'ri-bank-card-line',
      title: '提款到账',
      desc: '满足流水要求后随时提款，秒到无忧',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            领取彩金只需四步
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            简单快捷，轻松领取你的专属彩金
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {steps.map((s, i) => (
            <div key={s.step} className="relative text-center">
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(50%+40px)] w-[calc(100%-80px)] h-[1px] bg-background-300"></div>
              )}
              <div className="w-20 h-20 mx-auto rounded-full bg-primary-50 flex items-center justify-center mb-4">
                <i className={`${s.icon} text-2xl text-primary-500`}></i>
              </div>
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center -mt-2">
                <span className="text-xs font-bold text-background-50">{s.step}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-1.5">{s.title}</h3>
              <p className="text-sm text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}